// extracted by mini-css-extract-plugin
export default {"recos":"z6-z","productCardOverride":"A6-z","rowHasBadge":"B6-z"};